import { Box } from "@chakra-ui/layout";
import { CircularProgress } from "@chakra-ui/progress";
import * as React from "react";

export function LoadingApp() {
  return (
    <Box h="100%" position="relative">
      <CircularProgress
        isIndeterminate
        size={8}
        color="var(--okhi-spinner-color)"
        position="absolute"
        top="50%"
        left="50%"
        transform="translate(-50%, -50%)"
      />
    </Box>
  );
}
